export type Rule = {
  name: string;
  active: boolean;
  comment?: string;
  [key: string]: unknown;
};

export type Option = {
  label: string;
  value: string;
  url?: string | undefined;
};

export type Input = {
  name: string;
  label: string | null;
  type: string;
  options?: Option[];
  [key: string]: unknown;
};

export type StatementGroup = {
  group: string;
  options: Statement[];
  statements?: Statement[];
};

export type Statement = {
  name: string;
  label: string;
  value: string;
  inputs?: Input[];
  inputsLayout?: string;
  help?: string;
};

export type RulesData = {
  rules: Rule[];
  statements: StatementGroup[];
};

export const COLUMN = 'column';
export const ROW = 'row';

export const LAYOUTS: Record<string, string> = {
  vertical: COLUMN,
  horizontal: ROW,
};

export const DEFAULT_LAYOUT = 'horizontal-horizontal';
